import { render } from "./BudgetChart.vue?vue&type=template&id=66f86457&scoped=true&ts=true"
import script from "./BudgetChart.vue?vue&type=script&lang=ts"
export * from "./BudgetChart.vue?vue&type=script&lang=ts"

import "./BudgetChart.vue?vue&type=style&index=0&id=66f86457&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f86457"]])

export default __exports__